import { Component, ChangeDetectionStrategy } from '@angular/core';
import { LibTableComponent } from 'tuain-ng-forms-lib';
import { IconDictionaryService } from 'src/app/services/icon-dictionary.service';

const SEARCH_ICON = 'SEARCH';
const CHECKED_ICON = 'CHECKED';
const UNCHECKED_ICON = 'UNCHECKED';
@Component({
  selector: 'app-grid-table',
  templateUrl: './app-grid-table.component.html',
  styles: [`
      .search-box { padding: 8px; }
      .search-box input { width: 188px; margin-bottom: 8px; display: block; }
      .search-box button { width: 90px; }
      .search-button { margin-right: 8px; }
    `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class AppGridTableComponent extends LibTableComponent {
  activeColumnSearch: any;
  activeSearchText: string;
  selectionSortable: boolean;
  selectionColumn: any;

  searchIcon: string;
  selectedIcon: string;
  unselectedIcon: string;

  constructor(public _iconDictionary: IconDictionaryService) {
    super();
    this.searchIcon = this._iconDictionary.mapIcon(SEARCH_ICON);
    this.selectedIcon = this._iconDictionary.mapIcon(CHECKED_ICON);
    this.unselectedIcon = this._iconDictionary.mapIcon(UNCHECKED_ICON);
  }

  override start() {
    super.start();
    this.selectionColumn = this.table?.columns?.find(item => item.fieldCode === this.table.selectionField);
    this.selectionSortable = this.selectionColumn?.sortable;
  }

  openSearch(column, visible) {
    this.activeColumnSearch = visible ? column : null;
    this.activeSearchText = this.activeColumnSearch?.filter?.values?.[0] ?? '';
  }

  search() {
    this.activeColumnSearch && this.table.addColumnFilter(this.activeColumnSearch.fieldCode, [this.activeSearchText], 'HAS');
    this.activeColumnSearch.filterVisible = false;
  }

  reset() {
    this.activeSearchText = '';
    this.activeColumnSearch && this.table.removeColumnFilter(this.activeColumnSearch.fieldCode);
    this.activeColumnSearch.filterVisible = false;
  }

  sortOrderHasChanged(column, direction) {
    this.tableColumnSort(column.fieldCode, direction);
  }
}
